import { render, staticRenderFns } from "./CockpitMatryoshkaItemHistoryListItem.vue?vue&type=template&id=0c96dcf1&scoped=true"
import script from "./CockpitMatryoshkaItemHistoryListItem.vue?vue&type=script&lang=js"
export * from "./CockpitMatryoshkaItemHistoryListItem.vue?vue&type=script&lang=js"
import style0 from "./CockpitMatryoshkaItemHistoryListItem.vue?vue&type=style&index=0&id=0c96dcf1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c96dcf1",
  null
  
)

export default component.exports